// extracted by mini-css-extract-plugin
export var image = "gW_b4";